module.exports = __webpack_public_path__ + "static/the-player-of-games-2d09e8ebc6bd44fa4df8553af2849925.jpg";